// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DealershipService } from '@services/dealership.service';
import { takeWhile } from 'rxjs';
import { SSOSuccessVideoModalComponent } from 'src/app/modals/sso-success-video-modal/sso-success-video-modal.component';
import { environment } from 'src/environments/environment';
import { getShortenedVideoDesc } from 'src/app/utils/utils';
import { SettingsService } from '@services/settings.service';

@Component({
    selector: 'deals-help-panel',
    templateUrl: './deals-help-panel.component.html',
    styleUrls: ['./deals-help-panel.component.scss'],
})
export class DealsHelpPanelComponent implements OnInit, OnDestroy {
    envVideoUrl: string = environment.videoSrcUrl;
    supportEmail: string;
    tenantSupportPhone: string;
    helpContent: any[];
    isReadMore = false;
    fullDesc =
        "Deal Jackets are created by clicking the Start Deal Jacket button in the Leads, Consumer Documents and Deals functions, as well as by clicking Express Upload in the left-hand navigation panel. Depending on how the Deal Jacket is initiated, some of the information will already be populated on the Start Deal Jacket screen. VIN is required, as are the buyer and Co-Buyer's first name, last name, email address and mobile phone number. You will also need to select how you want to add documents to the deal. The three methods are Express Upload, Custom Deal Type or Blank Deal. Once you have completed all the information, click the Start Deal Jacket button to proceed to the next step.";
    shortDesc = '';
    isComponentAlive = true;
    constructor(
        private readonly dialog: MatDialog,
        private readonly router: Router,
        private dealershipService: DealershipService,
        private readonly settingsService: SettingsService
    ) {}

    ngOnInit() {
        this.shortDesc = getShortenedVideoDesc(this.fullDesc);

        this.dealershipService.dealer$.pipe(takeWhile(() => this.isComponentAlive)).subscribe(async (dealer) => {
            ({ supportEmail: this.supportEmail, supportPhone: this.tenantSupportPhone } = await this.settingsService.getOemSettings(dealer.oemCode));
        });
    }

    readMore() {
        this.isReadMore = !this.isReadMore;
    }
    routeToHelp() {
        const url = this.router.serializeUrl(this.router.createUrlTree(['/dashboard/help']));
        window.open(url, '_blank');
    }

    openVideo(title: string, source: string): void {
        this.dialog.open(SSOSuccessVideoModalComponent, {
            width: '700px',
            closeOnNavigation: false,
            data: {
                videoTitle: title,
                videoSource: this.envVideoUrl + source,
            },
        });
    }

    ngOnDestroy() {
        this.isComponentAlive = false;
    }
}
